import { StatusIndicator } from '@strata/react-status-indicators';
import PropTypes from 'prop-types';

import { getMemberEligibilityStatusDisplay } from 'services/memberEligibilityStatus';
import { EnrollmentStatus } from 'services/memberHelpers';

const EnrollmentStatusToStatusIndicatorStatus = {
    [EnrollmentStatus.ACTIVE]: StatusIndicator.Status.SUCCESS,
    [EnrollmentStatus.INACTIVE]: StatusIndicator.Status.CAUTION,
    [EnrollmentStatus.PENDING]: StatusIndicator.Status.WARNING,
};

const EnrollmentStatusToStatusIndicatorMessage = {
    [EnrollmentStatus.ACTIVE]: 'ACTIVE',
    [EnrollmentStatus.INACTIVE]: 'TERMED',
    [EnrollmentStatus.PENDING]: 'MONITORING',
};

export const EnrollmentStatusIndicator = ({ status = undefined }) => (
    <StatusIndicator
        status={EnrollmentStatusToStatusIndicatorStatus[status]}
        message={EnrollmentStatusToStatusIndicatorMessage[status]}
        tooltipText={getMemberEligibilityStatusDisplay(status)?.tooltipText}
    />
);

EnrollmentStatusIndicator.propTypes = {
    status: PropTypes.oneOf(Object.values(EnrollmentStatus)),
};
